import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTimeout from './baseQueryWithTimeout';

export const documentApi = createApi({
  reducerPath: 'documentApi',
  baseQuery: baseQueryWithTimeout,
  endpoints: (builder) => ({
    getAllDocuments: builder.query({
      query: ({ partnerNumber, auth0Token }) => ({
        url: '/api/v3/document/getAllDocuments',
        headers: { Brandpartner: partnerNumber, customAuthToken: auth0Token }
      })
    }),
    downloadDocument: builder.mutation({
      query: ({ policyNumber, attachmentId, auth0Token }) => ({
        url: `/api/policy/DownloadDocument/${policyNumber}/${attachmentId}`,
        method: 'GET',
        responseHandler: (response) => response.blob()
      })
    })
  })
});

export const { useGetAllDocumentsQuery, useDownloadDocumentMutation } = documentApi;
